export default __webpack_public_path__ + "static/desk05-db3956ebc54d367af435a65deca2364c.png";